<script>
  import { onMount, createEventDispatcher } from "svelte";
  import { fade, fly, crossfade } from "svelte/transition";
  import Inview from "./Inview.svelte";
  import { hexToRgbA } from "./helpers.js";
  import { swipe } from "svelte-hammer";
  const [send, receive] = crossfade({});
  import {
    ChevronLeftIcon,
    ChevronRightIcon,
    ArrowLeftIcon,
    ArrowRightIcon,
    ArrowLeftCircleIcon,
    BookOpenIcon,
  } from "svelte-feather-icons";
  import AudioControls from "./AudioControls.svelte";

  export let data;
  export let i;
  export let h;
  export let currentAudio;
  export let universalMode;
  export let currentIndex;
  export let p;

  export let showSources;
  let slide = -1;

  let paused;
  let wrapper;
  let audioEl;
  let percentage = 0;
  let showTranscript = false;
  let w;
  let links = data.links || [];
  $: op = universalMode ? 0.15 : 1;
  $: f = universalMode ? "grayscale(100%)" : "none";
  $: fg = universalMode ? "#000000" : data.fg;
  $: bg = universalMode ? "#ffffff" : data.bg;

  let currentArticle;

  function openArticle(url) {
    currentArticle = url;
  }

  function closeArticle() {
    currentArticle = false;
  }

  const dispatch = createEventDispatcher();

  function enter(v) {
    dispatch("enter", {
      i: i,
      el: wrapper,
      fg: data.fg,
      bg: data.bg,
      mode: data.mode,
      shadow: data.shadow,
      title: data.title,
    });
  }


  $: dispatch('sources', showTranscript )

  function play(v) {
    dispatch("play", {
      src: data.audio,
    });

    audioEl.play();
  }

  function pause(v) {
    dispatch("pause", {
      src: data,
    });
    audioEl.pause();
  }

  function seek(t) {
    currentAudio.currentTime = currentAudio.currentTime + t;
  }

  function nextSlide() {
    slide = Math.min(data.links.length - 1, slide + 1);
  }

  function prevSlide() {
    slide = Math.max(-1, slide - 1);
  }


function openSources(){
  showSources = true;
  dispatch("sources", showSources);

}

function closeSources(){
  showSources = false;
  console.log('dispatching close')
  dispatch("sources", showSources);
}
</script>

<svelte:window bind:innerWidth={w} />

<Inview {wrapper} threshold={0.5} on:enter={enter}>
  <section
    bind:this={wrapper}
    style="--fg:{fg};--bg:{bg};--shadow:{data.shadow};height:{h}px"
    id={data.slug}
    name={data.slug}
  >
    <div
      class="background"
      style="background-image:linear-gradient(
      rgba(0, 0, 0, .05),
      rgba(0, 0, 0, .25)
    ), url(/lassen/img/{data.img});filter:{f};opacity:{op}"
    />

    <!-- linear-gradient(
      rgba(0, 0, 0, 0),
	  rgba(0, 0, 0, 0),
      rgba(0, 0, 0, 0)
    ), -->
    
    {#if !universalMode && false}
      <div
        transition:fade
        class="overlay"
        style="background-color:{data.bg};mix-blend-mode:{data.mode};opacity:{percentage}"
      />
    {/if}

    <div class="foreground">
      <div class="center">
        <div class="spacer top" />
        <div
          class="content"
          use:swipe
          on:swipeleft={openSources}
        >
          <div class="opener">
            <h2>
              {#if data.link}
                <a href={data.link} target="_blank">{data.title}</a>
              {:else}
                {data.title}
              {/if}
            </h2>

            {#if data.links}
              <button
                on:click={openSources}
                class="sources-trigger"
              >
                Learn More
              </button>
            {:else if data.link}
              <button class="sources-trigger">
                <a href={data.link} target="_blank">Learn More</a></button
              >
            {/if}
          </div>
        </div>
        <div class="spacer actions">
          {#if data.audio}
            <div class="action controls">
              <AudioControls
                {data}
                bind:percentage
                bind:showTranscript
                bind:paused
                bind:universalMode
                bind:fg
                bind:bg
              />
            </div>
          {/if}
        </div>
      </div>
    </div>
  </section>
</Inview>

{#if data.links && data.links.length && showSources}
  <div
    class="sources-container"
    transition:fly={{ opacity: 1, x: w }}
    use:swipe
    on:swiperight={closeSources}
    style="--fg:{fg};--bg:{bg};--shadow:{data.shadow};height:{h}px"
  >
    <!-- <div class="sources-overlay" /> -->
    <div class="sources">
      <!-- <h2>{@html data.title}</h2> -->

      <div class="modal-header">
        <button
          on:click={() => {
            if (currentArticle) {
              currentArticle = false;
            } else {
              closeSources();
            }
          }}
          class="sources-back"
        >
          <ArrowLeftIcon size="22" strokeWidth="2" />
        </button>
        <span>Further Reading</span>
      </div>

      <div class="article slide-content">
        {#if !currentArticle}
          {#each data.links as link}
           
              <h3>
                <a href={link.url} target="_blank">
                {@html link.title || ""}
                </a>
              </h3>
              <p class="source">
                <!-- <a href={data.links[slide].url}> READ </a> -->
                {#if link.author}
                  <span class="author">{@html link.author}</span>
                {/if}
                {#if link.publication}
                  {@html link.publication}
                {/if}
              </p>
       
          {/each}
        {/if}
      </div>
    </div>
  </div>
{/if}

{#if showTranscript}
  <div
    class="transcript-container"
    transition:fly={{ opacity: 1, y: h }}
    style="--fg:{fg};--bg:{bg};--shadow:{data.shadow};height:{h}px"
  >
    <div class="transcript-overlay" />
    <div class="transcript-header">
      <button
        class="close"
        on:click={() => (showTranscript = false)}
        on:touchend={() => (showTranscript = false)}>&times;</button
      >
      <span>Transcript</span>
    </div>
    <div class="transcript-text">
      <div class="transcript-inner">
        {@html data.transcript}
      </div>
    </div>
  </div>
{/if}

<style>
  section {
    width: 100%;
    scroll-snap-align: start;
    text-align: center;
    position: relative;
    z-index: 1;
    color: var(--fg);
    background-color: var(--bg);
    /* min-height: 100% ; */
    will-change: height;
    transition: height 100ms ease-out;
    word-break: normal;

    /* hyphens: auto; */
  }

  .center {
    display: flex;
    flex: 3;
    flex-direction: column;
    margin: 0;
  }

  .content {
    width: 100vw;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1.5rem;
  }

  /* .content.carousel {
    overflow-x: auto;
    display: flex;
    flex-wrap: nowrap;
    width: 80vw;
    scroll-snap-type: x mandatory;
    -webkit-overflow-scrolling: touch;
  }

  .carousel > * {
    width: 100%;
    flex: 0 0 auto;
    scroll-snap-align: start;
  } */

  .content {
    /* padding-bottom:2em; */
  }
  .background,
  .overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
  }

  .background {
    width: 100%;
    height: 100vh;
    z-index: 0;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
  }

  .overlay {
    z-index: 1;
  }

  .foreground {
    position: inherit;
    height: 100%;
    display: flex;
    z-index: 2;
    will-change: height;
    transition: height 100ms ease-out;
  }

  .foreground.playing {
    min-height: calc(100vh - 3rem);
    height: calc(100vh - 3rem);
  }

  .spacer {
    flex: 0.5;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    width: 100vw;
    /* border:2px solid blue; */
  }

  .spacer.top {
    flex: 0.5;
  }

  .content .spacer {
    min-width: 1.5em;
  }

  .actions {
    /* background-image: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.4)); */
    font-size: 2em;

    /* padding-bottom: 1em; */
  }

  .gradient-top {
  }

  .links {
  }

  .action {
    text-decoration: underline;
    text-underline-offset: 0.2em;
    text-decoration-thickness: 3px;
  }

  .spacer.actions {
    align-items: flex-start;
    position: relative;
  }

  .opener h2 {
    margin: 0 auto;
    text-align: center;
    position: relative;
    font-size: 1.75em;
    margin: 0 0 0 0;
    height: 100%;
    padding-top: calc(1em);
  }

  .pill {
    background-color: var(--fg);
    mix-blend-mode: screen;
    background-color: white;
    color: black;
  }

  .author::after {
    content: ", ";
  }

  .readmore {
    margin: 0 auto;
    text-align: center;
    position: relative;
    text-decoration: underline;
    text-underline-offset: 0.2em;
    text-transform: uppercase;
  }

  .screen {
    mix-blend-mode: screen;
  }

  .transport {
    display: flex;
    justify-content: center;
  }

  .overlay {
    pointer-events: none;
    background-image: linear-gradient(rgba(255, 0, 0, 0), rgba(255, 0, 0, 0.6));
    mix-blend-mode: screen;
  }

  .article {
    width: 100%;
    font-size: 1.25em;
    text-align: left;
    padding: 0 0 0 0;
    margin-top: 1em;
    margin-bottom: 1.5em;
    margin-left: 0.1rem;
  }

  /* .article:before {
    display: block;
    text-align: center;
    letter-spacing: 1px;
    font-size: 0.5em;
    content: "FURTHER READING";
    text-transform: uppercase;
  } */

  .article h3 {
    /* font-size:2em; */
    font-size: 1em;
    margin: 0.25rem 0 0 0;
    line-height: 1.2em;
  }

  .sources-back {
    position: absolute;
    left: 0;
    top: 0;
    padding: 0;
  }

  .article p.source {
    /* font-family:"Unica77", Helvetica, Roboto, Arial, sans-serif; */
    font-size: 0.8em;
    text-transform: uppercase;
    text-align: left;
    margin-top: 0.25em;
    line-height: 1.4em;

    text-transform: uppercase;
    letter-spacing: 1px;
  }

  .article p.source::before {
    /* content: "—"; */
  }

  :global(.carousel > .slides > div) {
    display: flex;
    align-items: center;
  }

  .sources {
    position: relative;
    line-height: 1.2em;
    text-align: left;
    padding-top: 0;
  }

  .sources h2 {
    text-align: center;
    font-size: 1rem;
    line-height: 1.2em;
    margin-bottom: 4em;
  }

  .sources .modal-header {
    margin-bottom: 3em;
    position: relative;
  }

  .transcript-overlay,
  .sources-overlay {
    position: fixed;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    background: var(--bg);
    pointer-events: none;
    touch-action: none;
  }

  .transcript-container,
  .sources-container {
    line-height: 1.5em;
    position: fixed;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    color: var(--fg);
    z-index: 101;
    padding: 1rem 2rem;
  }

  .sources-container {
    overflow-y: auto;
    padding: 1.5rem 1.5rem 5rem 1.5rem;
    background-color: var(--bg);
  }

  .transcript-text {
    z-index: 55;
    position: fixed;
    left: 0;
    top: 3rem;
    right: 0;
    bottom: 0;
    overflow-y: auto;
    padding: 1rem 2rem;
    font-family: "Unica77", Helvetica, Roboto, sans-serif;
  }

  .transcript-inner {
    max-width: 36em;
    margin-left: auto;
    margin-right: auto;
  }

  .close {
    position: fixed;
    right: 1rem;
    top: 0.5rem;
  }

  .transcript-header,
  .modal-header {
    font-size: 1em;
    text-transform: uppercase;
    letter-spacing: 1px;
    text-decoration: underline;
    text-underline-offset: 0.2em;
    text-decoration-thickness: 3px;
    text-align: center;
  }

  .transcript-header span {
    position: relative;
  }

  :global(.carousel ul) {
    padding-top: 1rem !important;
  }

  :global(.carousel ul li) {
    background-color: transparent !important;
    border: 1px solid var(--fg) !important;
    width: 0.75rem !important;
    height: 0.75rem !important;
  }

  :global(.carousel ul li.active) {
    background-color: var(--fg) !important;
    border: 1px solid var(--fg) !important;
  }

  :global(button.right) {
    right: 0 !important;
  }

  :global(button.left) {
    left: 0 !important;
  }

  .morebutton {
    padding: 0.25em 0.5em;
    border: 2px solid var(--fg);
  }

  .sources-trigger {
    margin-top: 0.5em;
    padding-top: 0.5em !important;
    text-transform: uppercase;
    letter-spacing: 1.5px;
    text-decoration: underline;
    text-underline-offset: 0.35em;
    text-decoration-thickness: 3px;
  }

  :global(ul){
    list-style-position: outside;
  }

  :global(li){
    margin-bottom:.5em;
  }

  iframe{
    position:fixed;
    top:4rem;
    left:0;
    right:0;
    bottom:0;
  }

  @media screen and (min-width: 1024px) {
    .content {
      width: 80vw;
    }

    .action {
      margin-top: 0;
    }
    h2 {
    }
  }
</style>
